<template>
  <div>
    <v-row>
      <v-col>
        <v-container class="bg-white">
          <v-row>
            <v-chip
              v-if="monthlyReportMail.draft == true"
              class="ma-2"
              color="light-green"
              text-color="white"
            >
              <v-icon
                left
                class="mr-1"
                icon="mdi-email-edit-outline"
              />
              下書き中
            </v-chip>
            <v-chip
              v-if="monthlyReportMail.waitingToSend == true"
              class="ma-2"
              color="orange"
              text-color="white"
            >
              <v-icon
                left
                class="mr-1"
                icon="mdi-send-clock"
              />
              送信予約済
            </v-chip>
            <v-chip
              v-if="monthlyReportMail.isSent == true"
              class="ma-2"
              color="blue"
              text-color="white"
            >
              <v-icon
                left
                class="mr-1"
                icon="mdi-send-check"
              />
              送信済
            </v-chip>
          </v-row>
          <v-row>
            <v-col md="1" class="text-no-wrap">
              TO:
            </v-col>
            <v-col md="11">
              <span>{{ monthlyReportMail.to }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="1" class="text-no-wrap">
              Cc:
            </v-col>
            <v-col md="11">
              <span>{{ mailCc }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="1" class="text-no-wrap">
              差出人:
            </v-col>
            <v-col md="11">
              <span>{{ monthlyReportMail.from }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="1" class="text-no-wrap">
              件名:
            </v-col>
            <v-col md="11">
              <span>{{ monthlyReportMail.title }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="1" class="text-no-wrap">
              本文:
            </v-col>
            <v-col md="11">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div class="text-pre-wrap">{{ monthlyReportMail.body }}</div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row
      class="mt-3"
      justify="center"
    >
      <v-btn
        v-if="monthlyReportMail.draft == true"
        variant="flat"
        border="md"
        class="mr-2 text-glance-primary font-weight-bold border-current"
        @click="editMail"
      >
        編集
      </v-btn>

      <v-btn
        v-if="monthlyReportMail.draft == true && monthlyReportMail.readyToSend == true"
        variant="flat"
        border="0"
        :color="color.mainColor()"
        class="ml-2 text-white font-weight-bold"
        @click="sendMail"
      >
        送信
      </v-btn>

      <v-btn
        v-if="monthlyReportMail.waitingToSend == true && monthlyReportMail.isSent == false"
        variant="flat"
        border="md"
        class="text-glance-primary font-weight-bold border-current"
        @click="cancelMail"
      >
        送信キャンセル
      </v-btn>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from "vue"
import { useStore } from "../../stores/index"
import { textFormatter } from "../../service/text_formatter"
import { themeColor } from "../../service/theme_color"

export default defineComponent({
  name: "MonthlyMailViewPart",
  setup() {
    const store = useStore()
    const newLineCodeToBr = textFormatter().newLineCodeToBr
    // settings
    const color = themeColor()

    // data
    const mailCc = ref("business@kids-public.co.jp")
    const monthlyReportMail = computed(() => store.getters.monthlyReportMail)

    const editMail = () => {
      store.dispatch("commitMonthlyReportMailEditable", true)
    }

    const cancelMail = () => {
      if(confirm("メール送信をキャンセルします。よろしいですか？")) {
        store.dispatch("cancelMonthlyReportMail", monthlyReportMail.value.id)
      }
    }

    const sendMail = () => {
      store.dispatch("fixMonthlyReportMail", monthlyReportMail.value)
    }

    return {
      monthlyReportMail,
      mailCc,
      cancelMail,
      newLineCodeToBr,
      editMail,
      sendMail,
      color
    }
  }
})
</script>
<style lang="scss">
  .text-pre-wrap {
    white-space: pre-wrap;
  }
</style>
